const UploadDonation = () =>  import('./UploadDonationView/UploadDonation.vue') ;
const ThanksPage = () =>  import('./ThanksPage.vue');
const PageNotFound = () =>  import('../common/PageNotFound.vue');

import { ZgRouter } from '@/models/ZgRouter';

const zgRouter = new ZgRouter();

zgRouter.addRoute('upload-donation', UploadDonation, '');
zgRouter.addRoute('thanks-page', ThanksPage, '/thanks');
zgRouter.addRoute('page-not-found', PageNotFound);

zgRouter.addUrlRedirect('*', '/page-not-found');

zgRouter.createVueRouter();

export default zgRouter;
